import { developerUrlForPreset } from "@verbleif/shared/src/composables/AppStore/developerPortal";
import { useConfigStore } from "@verbleif/shared/src/composables/ConfigStore/useConfigStore";

const config = useConfigStore();

config.setInitialConfig({
  presetName: import.meta.env.VITE_CONFIG_PRESET_NAME,
  apiUrl: import.meta.env.VITE_API_URL,
  appEnv: import.meta.env.VITE_ENV_NAME,
  mercureUrl: import.meta.env.VITE_MERCURE_URL,
  cdnUrl: import.meta.env.VITE_CDN_URL,
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  loginClientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
  loginRedirect: import.meta.env.VITE_LOGIN_REDIRECT,
  authSidebarUrl: import.meta.env.VITE_AUTH_SIDEBAR_URL,
  developerUrl: import.meta.env.VITE_DEVELOPER_URL || developerUrlForPreset(import.meta.env.VITE_CONFIG_PRESET_NAME),
  skipOauth: import.meta.env.VITE_SKIP_OAUTH === "true",
});
